import React, { useContext } from "react";
import {
  StyledMainContainer,
  StyledAlfabetizacionContainer,
  StyledAlfabetizacionCard,
  StyledCardImage,
  StyledCardContent,
  StyledKnowMoreButton,
  StyledHeaderSection,
  StyledCreditCard,
  StyledBlogButton,
} from "./styled";
import { Typography, Grid } from "@mui/material";
import { colors } from "../../theme/colors";
import { AuthContext } from "../../context/authContext";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import WordPressPosts from "../../components/common/WordpressPost";

import glosarioImg from "../../img/glosario-financiero.png";
import libertadImg from "../../img/libertad-financiera.png";
import testImg from "../../img/test-bienestar.png";
import creditCardImg from "../../img/tarjeta-retos.webp";

export default function AlfabetizacionFinanciera() {
  const { idCliente } = useContext(AuthContext);
  const isLoggedIn = !!idCliente;

  const alfabetizacionItems = [
    {
      id: 1,
      title: "Glosario Financiero",
      description:
        "Un glosario financiero es una lista clara y sencilla de términos de dinero, explicados sin enredos.",
      highlightText: "¡Ideal para entender el mundo financiero sin miedo!",
      image: glosarioImg,
      borderColor: colors.orange.secondary,
    },
    {
      id: 2,
      title: "Libertad Financiera",
      description:
        "La libertad financiera es vivir sin preocuparse por el dinero, porque tus ingresos pasivos cubren tus gastos.",
      highlightText: "¡Es independencia, paz y posibilidades infinitas!",
      image: libertadImg,
      borderColor: colors.orange.secondary,
    },
    {
      id: 3,
      title: "Test Bienestar Financiero",
      description:
        "¿Quieres saber cómo estás con tu dinero? Haz un test de bienestar financiero: rápido, revelador y útil.",
      highlightText: "¡Descúbrelo y mejora desde hoy!",
      image: testImg,
      borderColor: colors.orange.secondary,
    },
  ];

  return (
    <div
      style={{ width: "100%", backgroundColor: "#003865", minHeight: "100vh" }}
    >
      {!isLoggedIn && <Header />}

      <StyledMainContainer white={false}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <StyledHeaderSection>
              <StyledCreditCard>
                <img src={creditCardImg} alt="Tarjeta BI" />
              </StyledCreditCard>

              <div className="header-content">
                <Typography variant="h3" className="main-title">
                  Alfabetización Financiera
                </Typography>
                <Typography className="main-description">
                  La alfabetización financiera es entender cómo manejar tu
                  dinero: ahorrar, invertir y gastar con inteligencia.
                </Typography>
                <Typography className="main-subtitle">
                  <strong>
                    ¡Te empodera para tomar mejores decisiones y vivir
                    tranquilo!
                  </strong>
                </Typography>
              </div>
            </StyledHeaderSection>
          </Grid>
          <Grid item xs={12} sx={{ overflow: "hidden" }}>
            <StyledAlfabetizacionContainer>
              <Grid
                container
                spacing={4}
                justifyContent="center"
                alignItems="flex-start"
              >
                {alfabetizacionItems.map((item) => (
                  <Grid
                    item
                    xs={12}
                    md={4}
                    key={item.id}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      marginTop: item.isCenter ? { xs: 0, md: "-2rem" } : 0,
                      zIndex: item.isCenter ? 2 : 1,
                    }}
                  >
                    <StyledAlfabetizacionCard
                      borderColor={item.borderColor}
                      isCenter={item.isCenter}
                    >
                      <StyledCardImage>
                        <img src={item.image} alt={item.title} />
                      </StyledCardImage>

                      <StyledCardContent>
                        <Typography variant="h6" className="card-title">
                          {item.title}
                        </Typography>
                        <Typography className="card-description">
                          {item.description}{" "}
                          <span className="highlight-text">
                            {item.highlightText}
                          </span>
                        </Typography>
                        <StyledBlogButton
                          onClick={() => {
                            window.location.href = "/tester";
                          }}
                        >
                          Conocer más
                        </StyledBlogButton>
                      </StyledCardContent>
                    </StyledAlfabetizacionCard>
                  </Grid>
                ))}
              </Grid>
            </StyledAlfabetizacionContainer>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h6"
              sx={{
                textAlign: "center",
                color: colors.orange.title,
                fontSize: "28px",
                fontWeight: 700,
                mt: "1rem",
              }}
            >
              Temas que podrían interesarte
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <WordPressPosts />
          </Grid>
        </Grid>
      </StyledMainContainer>

      {!isLoggedIn && <Footer />}
    </div>
  );
}
